import { useContext } from "react";
import { AppContext } from "@/App";
import { Plane, Briefcase, Mountain, Heart } from "lucide-react";

const ICONS = [Plane, Briefcase, Mountain, Heart];

export default function Services() {
  const { t } = useContext(AppContext);
  return (
    <section id="servizi" data-testid="services-showcase-section" className="border-y border-[rgba(212,175,55,0.1)] bg-[#0D0F12]">
      <div className="mx-auto max-w-7xl px-4 py-24 sm:px-6">
        <p className="label-accent">01 — {t.services.label}</p>
        <h2 className="font-display mt-3 text-3xl font-medium text-amber-100/90 sm:text-4xl">{t.services.title}</h2>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <div key={s.title} data-testid={`service-card-${i}`} className="card-surface p-6">
                <div className="mb-5 inline-flex rounded-full border border-[rgba(212,175,55,0.3)] p-3">
                  <Icon className="h-5 w-5 text-[#D4AF37]" />
                </div>
                <h3 className="font-display text-xl font-semibold text-white">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-neutral-400">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
